(() => {
  angular
    .module('app')
    .filter('fullEntitlement', fullEntitlement)
    // For backward compatibility only. Filter name don't need "Filter" suffix.
    // AngularJS automatically appends "Filter" to name for DI.
    .filter('fullEntitlementFilter', fullEntitlement);

  fullEntitlement.$inject = ['moment'];

  function fullEntitlement(moment) {
    return fullEntitlementFilter;

    function fullEntitlementFilter(value) {
      return value ? App.localize('FullEntitlementOnX', moment(value).format('L')) : '';
    }
  }
})();
